import React from 'react'
import { Switch, Route } from 'react-router-dom'
import HomePage from '../pages/HomePage'

import AdminHomePage from '../pages/AdminHomePage'
import Login from '../pages/Login'
import Trial from '../pages/Trial'
import Lessons from '../pages/Lessons'
import Classes from '../pages/Classes'
import Classes2 from '../pages/Classes2'
import Practice from '../pages/Practice'
import Marathon from '../pages/Marathon'
import MarathonRanking from '../pages/MarathonRanking'
import InnerPage from '../pages/InnerPage'
import Challenges from '../pages/Challenges'
import AdminLogin from '../pages/AdminLogin'
import AdminCourse from '../pages/AdminCourse'
import AdminGuest from '../pages/AdminGuest'
import AdminStudent from '../pages/AdminStudent'
import AdminVideo from '../pages/AdminVideo'
import AdminChallenges from '../pages/AdminChallenges'
import AdminMarathon from '../pages/AdminMarathon'
import AdminCompetition from '../pages/AdminCompetition'
import AdminSetting from '../pages/AdminSetting'
import AdminFile from '../pages/AdminFile'

import ChartView from '../pages/ChartView'
import ChartViewTeacher from '../pages/ChartViewTeacher'


import CompHome from '../pages/CompHome'
import CompLogin from '../pages/CompLogin'
import CompWait from '../pages/CompWait'
import CompRules from '../pages/CompRules'
import CompSee from '../pages/CompSee'
import CompListen from '../pages/CompListen'
import CompOnline from '../pages/CompOnline'
import CompRank from '../pages/CompRank_P'
const Content = () => (
  <Switch>
    <Route exact path='/' component={HomePage} />

    <Route  path='/login' component={Login} />
    <Route  path='/trial' component={Trial} />
    <Route  path='/inner' component={InnerPage} />
    <Route  path='/lessons2' component={Lessons} />
    <Route  path='/classes' component={Classes} />
    <Route  path='/classes2' component={Classes2} />
    <Route  path='/practice' component={Practice} />
    <Route  path='/marathon' component={Marathon} />
    <Route  path='/marathon_ranking' component={MarathonRanking} />
    <Route  path='/challenges2' component={Challenges} />
    <Route exact path='/sbadmin' component={AdminHomePage} />
    <Route  path='/sbadmin/login' component={AdminLogin} />
    <Route  path='/sbadmin/setting' component={AdminSetting} />
    <Route  path='/sbadmin/course' component={AdminCourse} />
    <Route  path='/sbadmin/guest' component={AdminGuest} />
    <Route  path='/sbadmin/video' component={AdminVideo} />
    <Route  path='/sbadmin/file' component={AdminFile} />
    <Route  path='/sbadmin/challenges' component={AdminChallenges} />
    <Route  path='/sbadmin/marathon' component={AdminMarathon} />
    <Route  path='/sbadmin/student' component={AdminStudent} />
    <Route  path='/sbadmin/competition' component={AdminCompetition} />
    <Route  path='/competition' component={CompHome} />
    <Route  path='/competition_login' component={CompLogin} />
    <Route  path='/competition_wait' component={CompWait} />
    <Route  path='/competition_rules' component={CompRules} />
    <Route  path='/competition_see' component={CompSee} />
    <Route  path='/competition_listen' component={CompListen} />
    <Route  path='/competition_online' component={CompOnline} />
    <Route  path='/comp_ranking' component={CompRank} />
    <Route  path='/chartview' component={ChartView} />
    <Route  path='/chartviewTeacher' component={ChartViewTeacher} />
  </Switch>
)

export default Content;
